<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'PettyCashFund_Title' | translateWF: 'Petty cash funds' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit) {
            <p-button [label]="'PettyCashFund_New' | translateWF: 'New fund'" icon="pi pi-plus" (click)="createFund()" />
          }
        </div>
      </div>
      <p class="text-sm text-[var(--p-text-muted-color)]">
        {{ 'PettyCashFund_Subtitle' | translateWF: 'Cash held by a custodian and replenished from the bank as it is spent.' }}
      </p>
    </div>

    <div class="cs-summary-grid">
      <p-card data-variant="summary" [header]="'PettyCashFund_Kpi_Active' | translateWF: 'Active funds'">
        <ng-template pTemplate="subtitle">{{ summary()?.activeFunds ?? 0 }}</ng-template>
        {{ 'PettyCashFund_Kpi_Of' | translateWF: 'of' }} {{ summary()?.totalFunds ?? 0 }}
      </p-card>
      <p-card data-variant="summary" [header]="'PettyCashFund_Kpi_Authorized' | translateWF: 'Authorized amount'">
        <ng-template pTemplate="subtitle">{{ authorizedLabel() }}</ng-template>
        {{ 'PettyCashFund_Kpi_Authorized_Unit' | translateWF: 'active funds' }}
      </p-card>
      <p-card data-variant="summary" [header]="'PettyCashFund_Kpi_ReadyForFunding' | translateWF: 'Ready for funding'">
        <ng-template pTemplate="subtitle">{{ summary()?.readyForFundingFunds ?? 0 }}</ng-template>
        {{ 'PettyCashFund_Kpi_ReadyForFunding_Unit' | translateWF: 'awaiting the treasurer' }}
      </p-card>
    </div>

    <div class="cs-page-list-grid">
      @if (showFilters() && filterConfig(); as config) {
        <div>
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'PettyCashFund_Title' | translateWF: 'Petty cash funds'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="items()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="number" style="width: 13rem">
                  {{ 'PettyCashFund_Col_Number' | translateWF: 'Number' }}
                  <p-sortIcon field="number" />
                </th>
                <th pSortableColumn="name">
                  {{ 'PettyCashFund_Field_Name' | translateWF: 'Name' }}
                  <p-sortIcon field="name" />
                </th>
                <th pSortableColumn="custodian">
                  {{ 'PettyCashFund_Field_Custodian' | translateWF: 'Custodian' }}
                  <p-sortIcon field="custodian" />
                </th>
                <th>{{ 'PettyCashFund_Field_Policy' | translateWF: 'Approval policy' }}</th>
                <th pSortableColumn="authorizedAmount" class="text-right">
                  {{ 'PettyCashFund_Col_Authorized' | translateWF: 'Authorized amount' }}
                  <p-sortIcon field="authorizedAmount" />
                </th>
                <th pSortableColumn="status" style="width: 8rem">
                  {{ 'Status' | translateWF: 'Status' }}
                  <p-sortIcon field="status" />
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let row = getRow(rowData);
              <tr>
                <td>
                  <a class="cs-table-link font-mono" (click)="redirectToDetails(row.id)">{{ row.number }}</a>
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.custodian.displayName }}</td>
                <td>{{ policyLabel(row) }}</td>
                <td class="text-right font-mono">{{ symbolOf(row.currency) }} {{ row.authorizedAmount | number: '1.2-2' }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status)" />
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6" class="text-center">{{ 'PettyCashFund_Empty' | translateWF: 'No petty cash funds yet.' }}</td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
